import { render, staticRenderFns } from "./DownloadAdsWrapper.vue?vue&type=template&id=7ecf71cc"
import script from "./DownloadAdsWrapper.vue?vue&type=script&lang=js"
export * from "./DownloadAdsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports